
import api from './../helpers/api'

// const API_URL = 'https://localhost:8000/api';
// const API_URL = 'http://desktop-jr58gml/server/public/api';

class ReportService{

    get_sales_report(range){
        return api.post(`/sales_report`,{range:range}).then(
            response => {
                return response.data
            }
        );
    }
    get_my_sales_report(range){
        return api.post(`/my_sales_report`,{range:range}).then(
            response => {
                return response.data
            }
        );
    }

    //monthly reports
    get_by_month(date){
        return api.post(`/monthly`,{date},);
    }

    //get by user
    get_by_user(id,date){
        return api.post(`/user_report/${id}`,{date},);
    }

    get_summery_reports(start, end){
        return api.post(`/summery`,{start:start, end:end},);
        
    }
    async getDashboardSummary(){
        return await api.get(`/dashboard_summary`);
    }

    //get main graph
   async getStatistics(){
        return await api.get(`/maingraph`,);
        
    }
    //get main graph
   async getDailyStatistics(){
        return await api.get(`/daily_account`,);
        
    }
    //get product report
    get_product_report(start, end,id){
        return api.post(`/product_report`,{start:start, end:end,id:id},);
    }

    getAccounting(start, end) {
        const params = {};
        if (start) params.start = start;
        if (end)   params.end   = end;
        return api.get('/accounting', { params });
    }

    refund_item(item_id, quantity) {
        return api.post('/refund_sale_item', { item_id, quantity });
    }
}


export default new ReportService;